import { Filter } from '../filter';

export type Report = {
	id: number;
	name: string;
	created_at: Date;
	filters: Filter[];
};
